export const fetchText = async (url: string): Promise<string> => {
  const resp = await fetch(url)
  if (!resp.ok) {
    throw new Error(`Download failed (${resp.status})`)
  }
  return resp.text()
}

// Hands an in-memory file to the browser's save flow.
export const saveBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  // Some browsers ignore clicks on a link that isn't in the document.
  document.body.appendChild(link)
  link.click()
  link.remove()
  // Revoking synchronously can cancel the save in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
